import { render, staticRenderFns } from "./FooterPages.vue?vue&type=template&id=fb1b3d4e&scoped=true&"
import script from "./FooterPages.vue?vue&type=script&lang=js&"
export * from "./FooterPages.vue?vue&type=script&lang=js&"
import style0 from "./FooterPages.vue?vue&type=style&index=0&id=fb1b3d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1b3d4e",
  null
  
)

export default component.exports